import React from "react";
import Banner from "./Banner/Banner"
import ShitcoinDetail from "./ShitcoinDetail/ShitcoinDetail";
import FAQ from "./FAQ/FAQ";
import Footer from "./Footer/Footer";
const LandingPage = () => {
  return (
    <>
      <Banner />
      <ShitcoinDetail />
      <FAQ />
      <Footer />
    </>
  );
};

export default LandingPage;
